import { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, Grid, TextField } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { fetchAppointmentByUuid } from '../../../services/appointments';
import PatientSectionHeading from '../SeeUser/components/PatientSectionHeading';

const ViewConsultationPage = () => {
    const { uuid } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const { from, seeUserState } = location.state || {};

    const [consult, setConsult] = useState(null);
    const [loading, setLoading] = useState(true);

    const patientUuid = consult?.patient?.uuid;

    const handleBack = () => {
        if (from) {
            navigate(from.pathname, {
                state: {
                    ...from.state,
                    restoredState: seeUserState
                }
            });
        } else if (patientUuid) {
            navigate(`/users/user/${patientUuid}/consultas`);
        } else {
            navigate(-1);
        }
    };

    useEffect(() => {
        let active = true;
        setLoading(true);
        setConsult(null);
        const loadConsultation = async () => {
            try {
                const data = await fetchAppointmentByUuid(uuid);
                if (active) setConsult(data);
            } catch (err) {
                console.error('Erro ao carregar consulta', err);
            } finally {
                if (active) setLoading(false);
            }
        };

        loadConsultation();
        return () => {
            active = false;
        };
    }, [uuid]);

    if (loading) {
        return <Typography>A carregar consulta…</Typography>;
    }

    if (!consult) {
        return <Typography>Consulta não encontrada</Typography>;
    }

    const { notes } = consult;

    return (
        <Box mt={2} p={2}>
            <Card>
                <CardContent sx={{ backgroundColor: '#fff' }}>
                    <PatientSectionHeading
                        sectionLabel={t('userPage.sections.appointment')}
                        detailLabel={t('userPage.sections.consultationNotes')}
                        onBack={() => navigate(`/users/user/${patientUuid}`)}
                        onSectionBack={handleBack}
                    />

                    <Typography variant="h5" fontWeight={700} mb={1}>
                        Consulta
                    </Typography>

                    <Box
                        sx={{
                            height: 3,
                            width: 80,
                            backgroundColor: '#1976d2',
                            borderRadius: 2,
                            mb: 3
                        }}
                    />

                    <Grid container spacing={2}>
                        {/* NOTAS DA CONSULTA */}
                        <Grid item xs={12}>
                            <Typography variant="h5">Notas da Consulta</Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                multiline
                                minRows={6}
                                label="Descrição da consulta"
                                value={notes || ''}
                                disabled
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Box>
    );
};

export default ViewConsultationPage;
